export default "assets/images/texture_orange-39b19ca0.jpg";